import React, { useState, useEffect } from 'react';
import { Settings, Save, AlertCircle, CheckCircle } from 'lucide-react';
import { getSettings, updateSettings } from '../api/settingsApi';

export default function AdminSettings() {
    const [settings, setSettings] = useState({
        billingCycleDay: 7
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        loadSettings();
    }, []);

    const loadSettings = async () => {
        setLoading(true);
        try {
            const data = await getSettings();
            if (data) {
                setSettings({ billingCycleDay: data.billingCycleDay || 7 });
            }
        } catch (err) {
            console.error('Error loading settings', err);
            setError('Error al cargar la configuración global');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        try {
            await updateSettings(settings);
            setSuccess('Configuración actualizada exitosamente');
        } catch (err) {
            console.error('Error updating settings', err);
            setError('Error al actualizar la configuración');
        }
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="text-gray-500">Cargando...</div>
            </div>
        );
    }

    return (
        <div className="max-w-4xl mx-auto">
            <div className="mb-8">
                <h1 className="text-3xl font-bold text-gray-800 mb-2 flex items-center gap-2">
                    <Settings className="w-8 h-8 text-purple-600" />
                    Configuración Global
                </h1>
                <p className="text-gray-600">
                    Gestiona los ajustes generales del sistema aplicados a todos los usuarios
                </p>
            </div>

            {/* Alerts */}
            {error && (
                <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl flex items-start gap-3">
                    <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
                    <span className="text-red-700">{error}</span>
                </div>
            )}

            {success && (
                <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-xl flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <span className="text-green-700">{success}</span>
                </div>
            )}

            <div className="bg-white rounded-2xl shadow-lg p-6 mb-8 border border-purple-100">
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-4 border-b pb-2">
                            Ciclo de Facturación
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                    Día de Renovación Mensual
                                </label>
                                <input
                                    type="number"
                                    min="1"
                                    max="31"
                                    value={settings.billingCycleDay}
                                    onChange={(e) => setSettings({ ...settings, billingCycleDay: Number(e.target.value) })}
                                    className="w-full px-4 py-2 border-2 border-purple-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
                                    required
                                />
                                <p className="text-xs text-gray-500 mt-2">
                                    Este es el día que todas las nuevas renovaciones tomarán como fecha de anclaje (ej. el día 7 de cada mes).
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-end pt-4 border-t border-gray-100">
                        <button
                            type="submit"
                            className="px-6 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-xl font-semibold transition-all shadow flex items-center gap-2"
                        >
                            <Save className="w-5 h-5" />
                            Guardar Configuración
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
